// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__3wvlM","Open":"SideDrawer__Open__3xsf8","Close":"SideDrawer__Close__2S6c7","Logo":"SideDrawer__Logo__10IHv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/SideDrawer.css
// module id = 101
// module chunks = 3